import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers';
import { AppRouter } from './app/router';
import { registrarServiceWorker } from './lib/registrar-sw';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('No se ha encontrado el elemento #root');

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);

// Después de pintar: el modo sin conexión es un añadido, no un requisito para
// arrancar.
registrarServiceWorker();
